import React from 'react';
import { SchedulerTypes } from 'devextreme-react/scheduler';

type AppointmentProps = {
  data: { targetedAppointmentData: SchedulerTypes.Appointment; }
};

const formatTime = (date: Date | string | undefined): string => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' });
};

export const Appointment = (props: AppointmentProps) => {
  const { targetedAppointmentData } = props.data;
  const startTime = formatTime(targetedAppointmentData.RealStartDate || targetedAppointmentData.StartDate);
  const endTime = formatTime(targetedAppointmentData.RealEndDate || targetedAppointmentData.EndDate);
  return (
    <div>
      <div>
        {targetedAppointmentData.Completed && (
          <i className='dx-icon-check' />
        )}
        {startTime && endTime && (
          <span className='appointment-time'>{startTime} - {endTime}</span>
        )}
        {' '}{targetedAppointmentData.Text}
        <span> ({targetedAppointmentData.ActivityName})</span>
      </div>
    </div>
  );
};
